<template>
  <el-tooltip class="item" effect="dark" :content="$t('warehouse.orderEntry.print')" placement="top-start">
    <i class="el-icon-printer icon-action" @click="print" :class="{ 'reprint-icon-unit': labelPrinted }" ></i>
  </el-tooltip>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    unitId: {
      type: String,
      default: null
    },
    labelPrinted: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    print() {
      this.$store.dispatch('orderEntry/printUnit', this.unitId);
      this.$emit('update:labelPrinted', true);
    }
  }
};
</script>
